import { ActionReducerMap } from "@ngrx/store";
import { AppState } from "src/model/interface/app-state";
import * as fromHydrated from "src/state/hydrate";
import { AddressReducer } from "./reducers/address.reducer";
import { AreaReducer } from "./reducers/areas.reducer";
import { AuthenticationReducer } from "./reducers/authentication.reducer";
import {
  BuildingsReducer,
  CurrentBuildingReducer,
} from "../components/shared-components/state/reducers/building.reducer";
import { CardEnvironmentReducer } from "./reducers/card-environment.reducer";
import { CardProgrammerReducer } from "./reducers/card-programmer.reducer";
import { ChartReducer } from "./reducers/chart.reducer";
import { ClientSettingsReducer } from "./reducers/client-settings.reducer";
import { DeviceCardReducer } from "./reducers/device-card.reducer";
import {
  EnvironmentAccessControlMaintananceReducer,
  EnvironmentDeviceReducer,
  EnvironmentReducer,
  EnvironmentUserAccessOpenableReducer,
} from "./reducers/environment.reducer";
import {
  GatewayReducer,
  GatewaySettingsReducer,
} from "./reducers/gateway.reducer";
import { HistoryTransitReducer } from "./reducers/history-transit.reducer";
import { NotificationReducer } from "./reducers/notifications.reducer";
import { PlantCodesReducer } from "./reducers/plant-code.reducer";
import { CurrentPlantReducer, PlantsReducer } from "./reducers/plant.reducer";
import { ServerSettingsReducer } from "./reducers/server-settings.reducer";
import {
  GroupTimeSlotReducer,
  TimeSlotReducer,
} from "./reducers/time-slot.reducer";
import { TranslationReducer } from "./reducers/translation.reducer";
import { BlackBoxReducer } from "./reducers/black-box.reducer";
import { ScenarioReducer } from "./reducers/scenario.reducer";
import { ScenarioCommandsReducer } from "./reducers/scenario-commands.reducer";

export const AppReducers: ActionReducerMap<AppState> = {
  hydrated: fromHydrated.hydratedReducer,
  user: AuthenticationReducer,
  plants: PlantsReducer,
  currentPlant: CurrentPlantReducer,
  clientSettings: ClientSettingsReducer,
  serverSettings: ServerSettingsReducer,
  notifications: NotificationReducer,
  gateways: GatewayReducer,
  areas: AreaReducer,
  chart: ChartReducer,
  environments: EnvironmentReducer,
  environmentsDevices: EnvironmentDeviceReducer,
  environmentsAccessUserOpenable: EnvironmentUserAccessOpenableReducer,
  environmentAccessControlMaintanance:
    EnvironmentAccessControlMaintananceReducer,
  translations: TranslationReducer,
  timeSlots: TimeSlotReducer,
  groupTImeSlots: GroupTimeSlotReducer,
  deviceCardList: DeviceCardReducer,
  historyTransit: HistoryTransitReducer,
  gatewayssettings: GatewaySettingsReducer,
  cardEnvironments: CardEnvironmentReducer,
  treeaddress: AddressReducer,
  cardProgrammer: CardProgrammerReducer,
  plantCodes: PlantCodesReducer,
  buildings: BuildingsReducer,
  currentBuilding: CurrentBuildingReducer,
  blackBox: BlackBoxReducer,
  scenarios: ScenarioReducer,
  scenariosCommands: ScenarioCommandsReducer,
};
